import { motion } from "framer-motion";

export const Manifesto = ({ t }) => (
  <section id="warum-wir" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-36" data-testid="manifesto-section">
    <motion.p
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="text-xs uppercase tracking-[0.25em] font-bold text-taupe mb-6"
      data-testid="manifesto-overline"
    >
      {t.manifesto.overline}
    </motion.p>
    <motion.h2
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="font-heading font-light tracking-tight text-4xl md:text-5xl max-w-3xl leading-[1.05]"
      data-testid="manifesto-title"
    >
      {t.manifesto.title}
    </motion.h2>

    <div className="mt-16 md:mt-24">
      {t.manifesto.chapters.map((c, i) => (
        <div
          key={c.number}
          className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-14 md:py-20 border-t border-line"
          data-testid={`manifesto-chapter-${i + 1}`}
        >
          <div className="md:col-span-4">
            <span className="md:sticky md:top-28 block font-heading font-light text-7xl md:text-8xl lg:text-9xl text-taupe/50 leading-none">
              {c.number}
            </span>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-8"
          >
            <h3 className="font-heading text-3xl md:text-4xl font-medium" data-testid={`manifesto-chapter-title-${i + 1}`}>
              {c.title}
            </h3>
            <p className="mt-6 text-smoke text-base md:text-lg font-light leading-relaxed max-w-2xl" data-testid={`manifesto-chapter-desc-${i + 1}`}>
              {c.desc}
            </p>
          </motion.div>
        </div>
      ))}
    </div>
  </section>
);
